import {api} from "@/shared/api";
import {htmlEscape} from "@/shared/utils/string";
import * as BootstrapModal from "@/shared/ui/bootstrapModal";
import * as Input from "@/shared/utils/input";
import {FreeFeatureModuleResult} from "@/shared/timr";
import {FeatureModuleKey} from "@/shared/timrTypes";

const template = `
				<div id="freeModuleSelectionDialog">
					<div id="selectFreePlanGrid" class="feature-module-grid-view">
						
					</div>
					<div class="alert alert-primary no-margin-bottom mt-20">
						${messages["admin.payment.plan.free.note"]}
					</div>
				</div>
			`;

/**
 * Custom web component that draws the content of the feature module selection dialog.
 */
export class FreeModuleSelectionDialog extends HTMLElement {
	private _freeModules: FreeFeatureModuleResult[];
	private _closeCallback: () => void;

	get freeModules(): FreeFeatureModuleResult[] {
		return this._freeModules;
	}

	set freeModules(value: FreeFeatureModuleResult[]) {
		this._freeModules = value;
	}

	get closeCallback(): () => void {
		return this._closeCallback;
	}

	set closeCallback(value: () => void) {
		this._closeCallback = value;
	}

	public static show(freeModules: FreeFeatureModuleResult[], closeCallback?: () => void): void {
		const dialog = document.createElement("free-module-selection-dialog") as FreeModuleSelectionDialog;
		dialog.freeModules = freeModules;
		dialog.closeCallback = closeCallback;
		dialog.show();
	}

	private connectedCallback() {
		this.innerHTML = template;
		this.buildFeatureModuleDialog(this.freeModules);
	}

	private show(): void {
		new BootstrapModal.Modal({
			title: "pricing.freeModuleDialog.title",
			message: $(this),
			size: "modal-xl",
			destroyOnClose: true,
			buttons: [
				{
					text: "dialog.cancel",
					css: "cancelButton btn-default"
				},
				{
					text: "pricing.switchToFree",
					css: "saveButton btn-primary",
					action: (m) => {
						void api("account/selectFreeFeatureModule.json")
							.post({featureModuleKey: this.getSelectedFeatureModuleKey()})
							.done(() => {
								this.closeCallback();
								m.close();
							});
					}
				}
			],
			onOpen: () => {
				Input.disable($(".saveButton"));
				$("input").change(() => {
					Input.toggle($(".saveButton"), !!this.getSelectedFeatureModuleKey());
				});
			}
		}).show();
	}

	private getSelectedFeatureModuleKey(): FeatureModuleKey {
		return $("input[name='freeModuleRadio']:checked").val() as FeatureModuleKey;
	}

	private buildFeatureModuleDialog(freeModules: FreeFeatureModuleResult[]): JQuery {
		const grid = this.querySelector("#selectFreePlanGrid");
		for (const freeModule of freeModules ?? []) {
			const featureModule = this.createFeatureModuleElement(freeModule);
			grid.append(featureModule);
		}

		return $("#freeModuleSelectionDialog");
	}

	private createFeatureModuleElement(freeModule: FreeFeatureModuleResult): HTMLElement {
		const fmElement = document.createElement("div");
		fmElement.innerHTML = `
			<div class="panel panel-default p-15">
				<div class="flex-row">
					<label class="radio-inline h3 mt-0">
						<input type="radio" value="${freeModule.key}" name="freeModuleRadio" />
						<div style="padding-left: 1px">${htmlEscape(freeModule.name)}</div>
					</label>
				</div>
				<div class="flex-row pl-30">
					${htmlEscape(freeModule.description)}
				</div>
				<div class="flex-row pl-30">
					<ul class="feature-module-list">
						${freeModule.maxUsers ? `<li>${messages.withArguments("admin.payment.plan.user", freeModule.maxUsers)}</li>` : ""}
						${freeModule.maxWorkingTimeTypes ? `<li>${messages.withArguments("admin.payment.plan.workingTimeTypes", freeModule.maxWorkingTimeTypes)}</li>` : ""}
						${freeModule.maxActiveTasks ? `<li>${messages.withArguments("admin.payment.plan.activeTasks", freeModule.maxActiveTasks)}</li>` : ""}
						${freeModule.maxCars ? `<li>${messages.withArguments("admin.payment.plan.car", freeModule.maxCars)}</li>` : ""}
						${freeModule.maxDriveLogCategories ? `<li>${messages.withArguments("admin.payment.plan.driveLogCategories", freeModule.maxDriveLogCategories)}</li>` : ""}
						<li>${messages["admin.payment.plan.temporallyUnlimited"]}</li>
					</ul>
				</div>
			</div>
			`;
		return fmElement;
	}
}
